import { StickyFooterItem } from '../../../shared-extra/components/sticky-footer/sticky-footer.component';

export const GallerySettingsMenuItems: StickyFooterItem[] = [
  {
    key: 'access',
    icon: 'gear',
    text: 'General',
  },
  {
    key: 'review',
    icon: 'bolt',
    text: 'Review',
    newDot: 'gallery-settings-review',
  },
  {
    key: 'design',
    icon: 'annotate-brush',
    text: 'Design',
  },
  {
    key: 'download',
    icon: 'down-circle',
    text: 'Download',
  },
];
